import React, { useEffect, useState ,useRef} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
 
const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Portability_data = async () => {
    const response = await fetch(`${process.env.REACT_APP_URL_MIS}/api/Portability`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }, 
    });
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    return response.json();
  };
const Portability = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const fpstab = useRef(null); // Use ref to scroll to this div
   const [monthname,setMonthname] = useState([]);
   const [year,setYear] = useState([]);
   const [totals, setTotals] = useState([]); // State for storing column totals

   
   const calculateTotals = (data) => {
    const columnCount = data[0].districtdeteailslist.length;
    const columnTotals = new Array(columnCount).fill(0); 
    data.forEach(item => {
        item.districtdeteailslist.forEach((colItem, colIndex) => {
            columnTotals[colIndex] += parseInt(colItem.cards) || 0;  
        });
    });
    setTotals(columnTotals); 
 };

    useEffect(() => {
      const getData = async () => {
        try {
          const response_data = await Portability_data();
          setTabHeading(response_data.heading);
          if (response_data.potabilityListl && response_data.potabilityListl.length > 0) {
            setReportData(response_data.potabilityListl);
            setMonthname(response_data.monthname)
            setYear(response_data.year)
            
            calculateTotals(response_data.potabilityListl); 
           

          } else {
            setReportData([]);
          }
         } catch (errorr) {
          setError(error);
        } finally {
          setLoading(false);
        }
      };
  
      getData();
    },[]);
   
    if (loading) {
      return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
          <CircularProgress />
      </Box></div>
  }
  if (error) {
      return <div class="mainhead" align="center">
      Internal Error
      </div>
    }
    if (reportData.length === 0) {
        return <div class="mainhead" align="center">
		No data found 
 	</div>
      } 
      

      const S_totals = reportData.reduce(
        (acc, item) => {
           acc.inter_total_cards += item.port_in || 0;
          acc.intra_total_cards += item.port || 0;
          return acc;
        },
        {
           inter_total_cards: 0,
           intra_total_cards: 0,
        }
      );
    
    

    return (
      <>
      <br/><br/>
        <table ref={fpstab} align="center" width="90%" border={1}>
          <thead>
            <tr className="tableheader">
              <th colSpan={4+reportData[0].districtdeteailslist.length}> {'Portability Cards for '} <font style={{color:'orange'}} > {monthname} - {year} </font></th>
            </tr>
            <tr className="tableheader">
              <th rowSpan={3}>Sl.No</th>
              <th rowSpan={3}>District</th>
              <th colSpan={reportData[0].districtdeteailslist.length+2}>Portability Cards for <font style={{color:'orange'}}></font></th>
             
            </tr>
            <tr className="tableheader">
              <th rowSpan={2}>Intra<br/>District<br/>Cards</th>
              <th colSpan={reportData[0].districtdeteailslist.length}>Inter District</th>
              <th rowSpan={2}>Inter<br/>District<br/>Cards<br/>Total</th>
              </tr>
           <tr className="tableheader">
             {reportData[0].districtdeteailslist.map((item) => (
              <th style={{ textAlign: 'left' }}  key={item.dist_namee} >{item.dist_name_en}</th>
            ))}
            </tr>
          </thead>
          <tbody>
            {reportData.map((item, index) => {
 const totalCards = item.districtdeteailslist.reduce((sum, detail) => {
  return sum + parseInt(detail.cards, 10) || 0; 
}, 0);
              return (
               <tr key={item.dist_namee}>
                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                <td style={{ textAlign: 'left' }}> {item.dist_namee} </td>
                <td style={{ textAlign: 'right', backgroundColor:"#ff6633"  }}>{item.port_in}</td> 
                
 {item.districtdeteailslist.map((detail, idx) => (
                <td key={idx} style={{ textAlign: 'right' }}>
                  {detail.cards || 0}
                </td>
              ))}
                     
                 <td  style={{ textAlign: 'right' , backgroundColor:'#8585ad' }}> {totalCards} </td>
               </tr>
 );
})}            
          </tbody>
          <tfoot>
                    <tr className="tableheader">
                        <td colSpan={2}>Total</td>
                        <td  style={{ textAlign: 'right' }}>
                  {S_totals.inter_total_cards}
                </td>
                         {totals.map((total, index) => (
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total}</td>
                        ))}
                         <td  style={{ textAlign: 'right' }}>
                  {S_totals.intra_total_cards}
                </td>
                    </tr>
                </tfoot>
        </table>
        <br/><br/>
        <br/><br/>
      </>
    );
  };
  
  export default Portability;
  